/**
 * File extension of the document.
 */
export enum DocumentContentType {
  PDF = 'application/pdf',
}
